import { IntlShape } from 'react-intl';

// English fallbacks. The admin text catalog is replaced at runtime by
// /texts/admin (which has no fleetadmin.bulk.* keys), so every call site
// must pass defaultMessage or the raw id would render.
export const BULK_MESSAGES: Record<string, string> = {
  'fleetadmin.bulk.actions.button': 'Bulk Actions',
  'fleetadmin.bulk.actions.choose': 'CHOOSE AN ACTION',
  'fleetadmin.bulk.add.title': 'Bulk add users',
  'fleetadmin.bulk.create.title': 'Bulk create users',
  'fleetadmin.bulk.archive.title': 'Bulk archive users',
  'fleetadmin.bulk.archive.desc':
    'Keeps their data, removes app access. Cannot be undone.',
  'fleetadmin.bulk.tag.destructive': 'Destructive',
  // Bulk create (server-side /fleets/users/csv) — reuses the wizard visual
  // language but with create-specific wording.
  'fleetadmin.bulk.create.step.run': 'Create',
  'fleetadmin.bulk.create.dropzone.hint':
    'One user per row · first row is the header',
  'fleetadmin.bulk.create.button': 'Create users',
  'fleetadmin.bulk.create.progress': 'Creating {total} users…',
  'fleetadmin.bulk.create.doneOk': 'Done',
  'fleetadmin.bulk.create.doneErrors': 'Done with errors',
  'fleetadmin.bulk.create.createdCount': '{count} created',
  'fleetadmin.bulk.create.failedCount': '{count} failed',
  'fleetadmin.bulk.create.couldNotCreate':
    '{count, plural, one {# could not be created} other {# could not be created}}',
  'fleetadmin.bulk.create.footer.preview': 'Preview created users ›',
  'fleetadmin.bulk.create.preview.loading': 'Loading created users…',
  'fleetadmin.bulk.create.preview.title': '{count} users created',
  'fleetadmin.bulk.create.preview.sub':
    'The most recently created users, fetched from the list.',
  'fleetadmin.bulk.eyebrow': 'Bulk action',
  'fleetadmin.bulk.step.upload': 'Upload',
  'fleetadmin.bulk.step.preview': 'Preview',
  'fleetadmin.bulk.step.confirm': 'Confirm',
  'fleetadmin.bulk.upload.dropzone.title': 'Click or drag CSV here to upload',
  'fleetadmin.bulk.upload.dropzone.hint':
    'One identifier per row · header row optional',
  'fleetadmin.bulk.upload.detectedRows': 'Rows',
  'fleetadmin.bulk.upload.matchedColumn': 'Column',
  'fleetadmin.bulk.upload.noColumn': '(not found)',
  'fleetadmin.bulk.upload.filterBy': 'Filter by',
  'fleetadmin.bulk.upload.fileMeta': '{count} rows · {size} KB',
  'fleetadmin.bulk.upload.downloadTemplate': 'Download CSV template',
  'fleetadmin.bulk.upload.columnMissing':
    'No "{filter}" column in CSV. Add a header row with one of: {aliases}.',
  'fleetadmin.bulk.identifier.userId': 'User ID',
  'fleetadmin.bulk.identifier.userCode': 'User Code',
  'fleetadmin.bulk.preview.matched': '{count} matched',
  'fleetadmin.bulk.preview.matchedSub': '{total} identifiers · {file}',
  'fleetadmin.bulk.preview.downloadMatched': 'Matched CSV',
  'fleetadmin.bulk.preview.notFound':
    '{count} not found — skipped (no active user).',
  'fleetadmin.bulk.preview.downloadUnmatched': 'Unmatched CSV',
  'fleetadmin.bulk.preview.resolving': 'Resolving identifiers…',
  'fleetadmin.bulk.execute.progress': 'Archiving {done} of {total}…',
  'fleetadmin.bulk.execute.doneOk': 'Done',
  'fleetadmin.bulk.execute.doneErrors': 'Done with errors',
  'fleetadmin.bulk.execute.archivedCount': '{count} archived',
  'fleetadmin.bulk.execute.failedCount': '{count} failed',
  'fleetadmin.bulk.execute.submitted': 'SUBMITTED',
  'fleetadmin.bulk.execute.succeeded': 'SUCCEEDED',
  'fleetadmin.bulk.execute.failed': 'FAILED',
  'fleetadmin.bulk.execute.couldNotArchive':
    '{count, plural, one {# could not be archived} other {# could not be archived}}',
  'fleetadmin.bulk.execute.downloadFailed': 'Failed rows CSV',
  'fleetadmin.bulk.footer.rows': '{count} rows',
  'fleetadmin.bulk.footer.cancel': 'Cancel',
  'fleetadmin.bulk.footer.next': 'Next: Preview ›',
  'fleetadmin.bulk.footer.selected': '{selected} of {total} selected',
  'fleetadmin.bulk.footer.back': '‹ Back',
  'fleetadmin.bulk.footer.archive': 'Archive {count} users',
  'fleetadmin.bulk.footer.jobId': 'Job ID {id}',
  'fleetadmin.bulk.footer.runAnother': 'Run another',
  'fleetadmin.bulk.footer.done': 'Done',
  'fleetadmin.bulk.confirm.title':
    '{count, plural, one {Archive # user? This cannot be undone.} other {Archive # users? This cannot be undone.}}',
  'fleetadmin.bulk.identifier.merchantReference': 'merchantReference',
};

// Shared translate helper: always supplies the English defaultMessage so the
// string renders even though the runtime catalog lacks these ids.
export const makeT =
  (intl: IntlShape) => (id: string, values?: Record<string, any>) =>
    intl.formatMessage({ id, defaultMessage: BULK_MESSAGES[id] ?? id }, values);
